import React from "react";

function checkHighlight(r, text) {
  const isHot =
    ((r.typeDescription.includes('สองตัว') || r.typeDescription.includes('2ตัว')) && r.winRate >= 1.3) ||
    ((r.typeDescription.includes('สามตัว') || r.typeDescription.includes('3ตัว')) && r.winRate >= 0.13);

  return isHot ? <mark className="highlight-match">{text}</mark> : text;
}

const PERIOD_LABELS = [
  { key: 'dataAll', label: (y) => `ย้อนหลัง ${y} ปี`, accent: 'all' },
  { key: 'data1Year', label: () => 'ย้อนหลัง 1 ปี', accent: '1y' },
  { key: 'data3Years', label: () => 'ย้อนหลัง 3 ปี', accent: '3y' },
  { key: 'dataMonthMatch', label: (y) => `เดือนนี้ย้อนไป ${y} ปี`, accent: 'month' },
  { key: 'dataRoundMatch', label: (y) => `รอบนี้ย้อนไป ${y} ปี`, accent: 'round' },
];

export default function LottoResultItems({ results }) {
  const yearsFromBegin = new Date().getFullYear() - 1990;

  return (
    <div className="winrate-cards">
      {PERIOD_LABELS.map(({ key, label, accent }) => {
        const items = results[key];
        if (!items?.length) return null;

        return (
          <div key={key} className={`winrate-group winrate-group--${accent}`}>
            <h3 className="winrate-group__title">{label(yearsFromBegin)}</h3>
            <ul className="winrate-group__list">
              {items.map((r, i) => (
                <li key={i} className="winrate-card">
                  <span className="winrate-card__type">
                    {checkHighlight(r, r.typeDescription)}
                  </span>
                  <span className="winrate-card__rate">
                    {checkHighlight(r, `${r.winRate}%`)}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
}
